import React from 'react';
import { useQuery } from '@apollo/react-hooks';

import { SkeletonList } from 'components/shared/GroupsSidebar/components/GroupList/SkeletonList';
import { Group } from 'components/shared/Group';

import { useFeatureFlagState } from 'context';
import { GroupListQuery } from 'services';

interface GroupsListData {
  me: {
    groups: Group[];
    organization: Organization;
    orgGroup: Group;
    userProfile: User;
    otherPeople: User[];
  };
}

interface GroupListProps {
  className?: string,
}

export const GroupList = ({ className }:GroupListProps) => {
  const { groupsFeatureFlag } = useFeatureFlagState();

  const { error, data } = useQuery<GroupsListData>(GroupListQuery, {
    fetchPolicy: 'cache-and-network',
  });

  if (data === undefined) {
    return <SkeletonList />;
  }

  if (error) return <SkeletonList />;

  const groups = data.me.groups;

  if (!groupsFeatureFlag) {
    return <div className={className}><Group /></div>;
  }

  return (
    <div className={className}>
      {/* Group Create */}
      <Group />

      {groups.map((group) => {
        return (
          <Group
            key={group.id}
            group={group}
            collapsedByDefault={true}
            currentUserId={data!.me.userProfile.id}
          />
        );
      })}
    </div>
  );
};
